import axios from 'axios'

export default {
  async getControlCodes(params) {
    try {
      const response = await axios.get('GetControlCodes', { params })
      return response.data
    } catch (e) {
      if (e.response.status == 404) {
        return null
      } else {
        return Promise.reject(e)
      }
    }
  },
}
